import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-address',
  templateUrl: './new-address.component.html',
  styleUrls: ['./new-address.component.css']
})
export class NewAddressComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
